module.exports = __webpack_public_path__ + "static/xuling-zhu-3ecb95e5bb126af2ab820832c1dc05c6.mp4";